import type { Project } from './types/project';

// Project data array
export const projects: Project[] = [
  {
    title: "Berlin Budget Explorer",
    description: "An interactive tool for exploring and understanding Berlin's public budget, making fiscal data accessible to all.",
    category: "Design to Inform",
    context: "Civic Tech",
    image: "/projects/berlin-budget/Haushaltsk_rzungen Berlin 2025.jpeg",
    link: "/projects/berlin-budget-explorer",
    isVisible: true
  },
  {
    title: "Made to Measure",
    description: "An interactive data visualization tool for exploring and understanding complex measurements and metrics.",
    category: "Design to Inform",
    context: "Experience Design",
    image: "/projects/made-to-measure/m2m-data-exploration.mp4",
    link: "/projects/made-to-measure",
    isVideo: true,
    isVisible: true
  },
  {
    title: "AOK Design System",
    description: "A comprehensive design system for Germany's largest health insurance provider.",
    category: "Design to Inform",
    context: "Healthcare",
    image: "/projects/aok-design-system/mock.png",
    link: "/projects/aok-design-system",
    isVisible: true
  },
  {
    title: "Blanq",
    description: "A digital platform for exploring and understanding wine data.",
    category: "Design to Inform",
    context: "Fintech",
    image: "/projects/blanq/blanq-phone-and-cards.jpg",
    link: "/projects/blanq",
    isVisible: true
  },
  {
    title: "Pandemieradar",
    description: "A real-time visualization of COVID-19 data across Germany.",
    category: "Design to Inform",
    context: "Healthcare",
    image: "/projects/pandemieradar/pandemic-radar.webp",
    link: "/projects/pandemieradar",
    isVisible: true
  },
  {
    title: "Project Soli",
    description: "Developing gesture recognition technology for natural, touchless interactions.",
    category: "Design to Discover",
    context: "Emerging Tech",
    image: "/projects/soli/Soli Circle Demo.gif",
    link: "/projects/project-soli",
    isVideo: true,
    isVisible: true
  },
  {
    title: "Self-Driving Car Interactions",
    description: "Designing intuitive interactions for autonomous vehicles.",
    category: "Design to Discover",
    context: "Transportation",
    image: "/projects/self-driving-car/interface.mp4",
    link: "/projects/self-driving-car",
    isVideo: true,
    isVisible: true
  },
  {
    title: "The Known Unknowns",
    description: "Exploring uncertainty and ambiguity in design through experimental prototypes.",
    category: "Design to Discover",
    context: "Emerging Tech",
    image: "/projects/the-known-unknowns/DR_OCTAGON.jpg",
    link: "/projects/known-unknowns",
    isVideo: true,
    isVisible: true
  },
  {
    title: "Do You Like Working",
    description: "An interactive installation exploring work and personal identity.",
    category: "Design to Discover",
    context: "Emerging Tech",
    image: "/projects/do-you-like-working/exhibition-overview.jpg",
    link: "/projects/do-you-like-working",
    isVisible: true
  },
  {
    title: "The Gestalt of Digital Identity",
    description: "Investigating how digital identities form and evolve.",
    category: "Design to Discover",
    context: "Emerging Tech",
    image: "/projects/gestalt-digital-identity/print.jpg",
    link: "/projects/gestalt-digital-identity",
    isVisible: true
  },
  {
    title: "Design for Decisions",
    description: "A case study on designing systems for complex decision-making.",
    category: "Design to Discover",
    context: "Leadership & Strategy",
    image: "/projects/design-for-decisions/dfd-cover-hand.jpg",
    link: "/projects/design-for-decisions",
    isVisible: true
  },
  {
    title: "Is This Thing On?",
    description: "Teaching Information and Interface Design at leading art & design schools.",
    category: "Design to Discover",
    context: "Education",
    image: "/projects/itto/design-fiction.png",
    link: "/projects/is-this-thing-on",
    isVisible: true
  },
  {
    title: "Framing Art Science Technology",
    description: "Developing a postgraduate program bridging art, science, and technology.",
    category: "Design to Discover",
    context: "Education",
    image: "/projects/fast/fast-key.png",
    link: "/projects/framing-art-science-technology",
    isVisible: true
  }
];

// Helper function to get adjacent projects for navigation
export function getAdjacentProjects(currentProjectSlug: string) {
  // Filter only visible projects
  const visibleProjects = projects.filter(p => p.isVisible !== false);
  
  // Find current project
  const currentProject = visibleProjects.find(p => p.link === `/projects/${currentProjectSlug}`);
  
  if (!currentProject) {
    console.log('No current project found for slug:', currentProjectSlug);
    console.log('Available projects:', visibleProjects.map(p => p.link));
    return null;
  }
  
  // Find current project index
  const currentIndex = visibleProjects.findIndex(p => p.link === `/projects/${currentProjectSlug}`);
  
  // Get projects in the same category
  const sameCategory = visibleProjects.filter(p => p.category === currentProject.category);
  const currentCategoryIndex = sameCategory.findIndex(p => p.link === `/projects/${currentProjectSlug}`);
  
  let prevProject;
  let nextProject;

  // Try to get adjacent projects in the same category first
  if (sameCategory.length > 1) {
    prevProject = sameCategory[(currentCategoryIndex - 1 + sameCategory.length) % sameCategory.length];
    nextProject = sameCategory[(currentCategoryIndex + 1) % sameCategory.length];
  }

  // If we don't have category matches, fall back to the full visible project list
  if (!prevProject) {
    prevProject = visibleProjects[(currentIndex - 1 + visibleProjects.length) % visibleProjects.length];
  }
  if (!nextProject) {
    nextProject = visibleProjects[(currentIndex + 1) % visibleProjects.length];
  }

  return {
    currentProject,
    prevProject,
    nextProject
  };
}
